import { SvgIconProps } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";
// eslint-disable-next-line no-restricted-imports
import { CaretSvg } from "../icons/caret";

export const IconCaret = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <CaretSvg />
    </SvgIcon>
);
